var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Card, Collapsible, getTestId } from '@airtel/air-design-system';
import { cloneElement, useEffect, useRef, useState } from 'react';
import { Keyboard, View } from 'react-native';
import { withBoundaries } from '../../hoc';
import { getStepCardSectionStyles } from './StepCardSectionStyles';
var StepCardSectionComponent = props => {
  var _a;
  var id = props.id,
    onUserAction = props.onUserAction,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'AirStepCardSection' : _props$testID,
    children = props.children,
    isExpanded = props.isExpanded,
    childNoVerticalPadding = props.childNoVerticalPadding,
    childNoHorizontalPadding = props.childNoHorizontalPadding,
    onToggleMetaData = props.onToggleMetaData,
    _props$disableToggle = props.disableToggle,
    disableToggle = _props$disableToggle === void 0 ? false : _props$disableToggle,
    style = props.style,
    restProps = __rest(props, ["id", "onUserAction", "testID", "children", "isExpanded", "childNoVerticalPadding", "childNoHorizontalPadding", "onToggleMetaData", "disableToggle", "style"]);
  var StepCardSectionStyles = getStepCardSectionStyles();
  var collapsibleTogglerRef = useRef();
  var _useState = useState(isExpanded),
    internalIsExpanded = _useState[0],
    setInternalIsExpanded = _useState[1];
  useEffect(() => {
    var _a;
    (_a = collapsibleTogglerRef === null || collapsibleTogglerRef === void 0 ? void 0 : collapsibleTogglerRef.current) === null || _a === void 0 ? void 0 : _a.toggle(isExpanded);
    setInternalIsExpanded(isExpanded);
  }, [isExpanded]);
  useEffect(() => {
    var _a;
    if (!internalIsExpanded) {
      (_a = Keyboard === null || Keyboard === void 0 ? void 0 : Keyboard.dismiss) === null || _a === void 0 ? void 0 : _a.call(Keyboard);
    }
  }, [internalIsExpanded]);
  var handleClick = () => {
    var _a;
    if (!disableToggle) {
      (_a = collapsibleTogglerRef === null || collapsibleTogglerRef === void 0 ? void 0 : collapsibleTogglerRef.current) === null || _a === void 0 ? void 0 : _a.toggle();
    }
  };
  var titleComponent = children && (children[0] || children);
  var childComponents = children && !!children.length && children.slice(1);
  if (!titleComponent || ((_a = titleComponent.props) === null || _a === void 0 ? void 0 : _a.templateKey) !== 'AirLinkListItemWidget') {
    return null;
  }
  var titleComponentClone = cloneElement(titleComponent, {
    onPressHandler: () => {
      handleClick();
    },
    actionTypeOnPressHandler: () => {
      handleClick();
    },
    metaInfoCtaPressHandler: () => {
      handleClick();
    },
    infoIconPressHandler: () => {
      handleClick();
    },
    onRefreshCtaTimerCompleteHandler: () => {
      handleClick();
    }
  });
  return _jsx(Card, Object.assign({}, getTestId(testID), {
    style: style,
    noPadding: true
  }, restProps, {
    children: _jsx(Collapsible, Object.assign({
      showIcon: false,
      ref: collapsibleTogglerRef,
      titleNoHorizontalPadding: true,
      titleNoVerticalPadding: true,
      childNoHorizontalPadding: childNoHorizontalPadding,
      childNoVerticalPadding: childNoVerticalPadding,
      onToggleHandler: state => {
        onToggleMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, onToggleMetaData), {
          isExpanded: state
        }));
        setInternalIsExpanded(state);
      },
      titleComponent: _jsx(View, Object.assign({
        style: StepCardSectionStyles.titleComponent
      }, {
        children: titleComponentClone
      }))
    }, {
      children: childComponents
    }))
  }));
};
StepCardSectionComponent.genericRendererKey = 'AirStepCardSection';
StepCardSectionComponent.isAirSection = true;
export var StepCardSection = withBoundaries(StepCardSectionComponent);